import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { supportedLanguages, type SupportedLanguage } from '@/i18n';

/**
 * Hook para gestionar el idioma de la aplicación.
 * El idioma se establece según el campo `language` del hiring code (configurado por admin).
 */
export function useLanguage() {
  const { i18n } = useTranslation();

  const currentLang = (i18n.language || 'es') as SupportedLanguage;

  const setLanguage = useCallback(
    (lang: string) => {
      const normalizedLang = lang.substring(0, 2).toLowerCase();
      const validLang = supportedLanguages.includes(normalizedLang as SupportedLanguage)
        ? normalizedLang
        : 'es';
      void i18n.changeLanguage(validLang);
    },
    [i18n]
  );

  return {
    currentLang,
    setLanguage,
    availableLanguages: supportedLanguages,
  };
}
